import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import environmentVariables from "../config/environmentVariables";
const SuccessIcon = `${environmentVariables?.cdnUrl}successicon.png`


const Root = styled.div`
  position: fixed;
  /* top:100px; */
  /* background-color: #186e80; */
  /* border-radius: 10px; */
  /* width:80%; */
  /* width: 375px; */
  height: fit-content;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 1000;
  /* padding: 30px; */
  display: flex;
  flex-direction: column;
  ${(p) =>
    p.fullwidth &&
    `
      width:22%;
    `}
  @media(max-width:${(p) => p.theme.screen.md}) {
    width: 40%;
    left: 30%;
  }
  @media (max-width: ${(p) => p.theme.screen.sm}) {
    width: 50%;
    left: 25%;
  }
  @media (max-width: ${(p) => p.theme.screen.xs}) {
    width: 60%;
    left: 20%;
  }
  @media (max-width: ${(p) => p.theme.screen.xxs}) {
    width: 75%;
    left: 12.5%;
  }
  @media (max-width: ${(p) => p.theme.screen.xxxs}) {
    width: 85%;
    left: 7.5%;
  }
`;
const OverLay = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  bottom: 0;
  background-color: rgb(0 0 0 / 60%);
  left: 0px;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Heading = styled.div`
  font-size: 32px;
  text-align: center;
  color: #fff;
  margin: 10px 0 30px;
  @media(max-width:765px){
    font-size: 18px;
    margin: 10px 0 10px;
  }
`;
const Button = styled.button`
  background-color: #e9e9e9;
  color: #3a3a3a;
  justify-content: center;
  font-weight: 700;
  font-size: 18px;
  text-transform: uppercase;
  margin-top: ${(p) => p.theme.spacing.sm};
  font-family: ${(p) => p.theme.font.family.Lato};
  display: flex;
  align-items: center;
  padding: 10px 50px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  @media (max-width:765px){
    font-size: 14px;
  }
`;
const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
  background-color: ${(p) => p.theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${(p) => p.theme.radius.xs};
  @media (min-width: 1600px) {
    width: 40px;
    height: 40px;
  }
`;
const Icon = styled.img`
  width: 20px;
  @media (min-width: 1600px) {
    width: 24px;
  }
`;
const CloseButton = styled.div`
  position: absolute;
  top: 2px;
  right: 4px;
  cursor: pointer;
`;
const SuccessMain = styled.div`
  position: relative;
  color: #fff;
  border: 1px solid #484848;
  padding: 50px;
  min-width: 550px;
  border-radius: 10px;
  background-color: #2a2a2a;
  display: flex;
  align-items: center;
  flex-direction: column;
  @media (max-width:360px){
    min-width: 150px;
  }
  @media (max-width:765px){
    min-width: 300px;
    padding: 25px;
  }
`;
const SuccessIconI = styled.img`
  width: 70px;
  @media (max-width:765px){
    width: 40px;
  }
`;

const NftNameConfirm3 = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  /* padding-bottom: 20px; */
  padding-top: 20px;
  justify-content: space-between;
`;
const NftNameConfirm4 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 50px;
`;

const NftNameConfirm = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 20px;
  border-bottom: 1px solid #484848;
  border-top: 1px solid #484848;
  justify-content: space-between;
  margin: 20px 0;
`;

const NftConfirmImg = styled.img`
  width: 60px;
  height: 60px;
  background-color: #fff;
  border-radius: 10px;
`;

const NftNameConfirmHead = styled.div`
  font-size: 26px;
  font-weight: 600;
`;

const NftNameConfirmHeadUn = styled.div`
  text-align: center;
`;

const NftNameConfirmSubHead = styled.div`
  font-size: 16px;
  color: #bbb;
  text-transform: capitalize;
  @media (max-width:765px){
    font-size: 14px;
  }
`;
const AmountSubHead = styled.div`
  font-size: 16px;
  color: #6c6c6c;
  text-transform: capitalize;
  @media (max-width:765px){
    font-size: 10px;
    margin-top: 10px;
  }
`;
const DetailsHead = styled.div`
  display: flex;
  font-size: 16px;
  color: #fff;
  text-transform: capitalize;
  @media (max-width:765px){
    font-size: 14px;
  }
`;
const AmountHead = styled.div`
  font-size: 50px;
  font-weight: 600;
  color: #fff;
  padding-top: 5px;
  text-transform: capitalize;
  @media (max-width:765px){
    font-size: 14px;
  }
`;

const NftAmountConfirm = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 0 0;
`;
const NftAmountConfirmHeadPur = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
`;
const NftAmountConfirmHead = styled.div`
  font-size: 24px;
`;
const NftAmountConfirmSubHead = styled.div`
  font-size: 24px;
`;
const NftAmountConfirmHead2 = styled.div`
  font-size: 16px;
  color: #bbb;
`;
const NftAmountConfirmSubHead2 = styled.div`
  font-size: 16px;
  color: #bbb;
`;

const ButtonCancel = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -15px;
  right: -15px;
  background-color: #b3b3b3;
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 20px;
  /* font-weight: 600; */
  padding: 20px;
  margin: 0;
  cursor: pointer;
  color: #000;
  width: 45px;
  height: 45px;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
  }
  /* &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  } */
`;
const CopyIcon = styled.div`
  position: relative;
  color: white;
  cursor: pointer;
  padding: 0 0 0 15px;
  @media (max-width: 425px) {
    padding: 0 0 0 5px;
  }
`;
const ToolTipSpan = styled.span`
  width: 80px;
  background-color: #f3eded;
  color: #080808;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 145%;
  margin-left: -60px;
  opacity: 1;
  font-weight: 700;
  transition: opacity 0.3s;
  ::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #f3eded transparent transparent transparent;
  }
`;
const NftNameConfirmHash = styled.div`
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 18px;
  font-weight: 800;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: uppercase;
  background-color: #171e22;
  padding: 5px 20px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 10px;
  border: 1px solid #31393c;
  display: flex;
  align-items: center;
  max-height: 35px;
  justify-content: space-between;
`;

const ConfirmPopup = ({
  popUpText,
  setShowPopup,
  showPopup,
  onClickFun,
  text,
  viewFun,
  fullwidth,
  fetchDetails,
  autoClose,
  transactionHash,
  transactionFee,
  isList,
  price,
  currency,
}) => {
  // console.log("fetchDetailsfetchDetailsfetchDetails", fetchDetails);
  const handleClose = () => {
    if (autoClose) {
      setShowPopup(false);
    }
  };
  console.log(
    transactionFee,
    transactionHash,
    price,
    currency,
    "transaction details"
  );
  const navigation = useNavigate();
  const [historyData, setHistorydata] = useState();
  const [isCopied, setIsCopied] = useState(false);
  const handleCancelClick = () => {
    setShowPopup(false);
    onClickFun();
    navigation("/mynfts");
  };
  const CopyAddress = () => {
    try {
      if (transactionHash) {
        navigator.clipboard.writeText(transactionHash);
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 3000);
      }
    } catch (error) {
      console.error("Error copying text:", error);
      // toast.error("Copy failed");
    }
  };
  const currentDate = new Date();
  const monthAbbreviation = currentDate.toLocaleString("default", {
    month: "short",
  });

  const day = currentDate.getDate();
  const year = currentDate.getFullYear();
  let hours = currentDate.getHours();
  const minutes = currentDate.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  if (hours > 12) {
    hours -= 12;
  }

  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedDateTime = `${monthAbbreviation} ${day} ${year}, ${hours}:${formattedMinutes} ${ampm}`;
  const explorerHandler = () => {
    let explorerUrl = "";

    explorerUrl = `https://polygonscan.com/tx/${transactionHash}`;

    if (transactionHash) {
      window.open(explorerUrl, "_blank");
    } else {
      console.error("Invalid token name or transaction hash");
    }
  };
  // console.log("fetchDetailsfetchDetailsfetchDetails",fetchDetails)
  return (
    <OverLay>
      <Root
        fullwidth={fullwidth}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <SuccessMain>
          <ButtonCancel onClick={handleCancelClick}>x</ButtonCancel>
          <SuccessIconI src={SuccessIcon} />
          <Heading>{popUpText ? popUpText : `Transaction Successful`}</Heading>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: "18px",
                cursor: "pointer",
                color: "#cd2222",
                textTransform: "capitalize",
              }}
              onClick={explorerHandler}
            >
              view on explorer{" "}
              <span>
                <i class="fa-solid fa-arrow-up-right-dots"></i>
              </span>
            </div>
          </div>
          <NftNameConfirm>
            {/* <NftConfirmImg src={NftConfirmImg2}></NftConfirmImg> */}
            <div>
              <NftNameConfirmHead>{fetchDetails?.name}</NftNameConfirmHead>
              <NftNameConfirmSubHead>
                {fetchDetails?.category}
              </NftNameConfirmSubHead>
            </div>
            <NftNameConfirmHash>#{fetchDetails?.hash}</NftNameConfirmHash>
          </NftNameConfirm>
          <NftNameConfirm3>
            <NftNameConfirmSubHead>Transaction Hash :</NftNameConfirmSubHead>
            <DetailsHead>
              {`${transactionHash?.slice(0, 8)}...${transactionHash?.slice(
                -8
              )}` || ``}
              <CopyIcon onClick={CopyAddress}>
                <i class="fa-solid fa-copy"></i>
                {isCopied && <ToolTipSpan>Copied</ToolTipSpan>}
              </CopyIcon>
            </DetailsHead>
          </NftNameConfirm3>
          <NftNameConfirm3>
            <NftNameConfirmSubHead>Transaction Fee :</NftNameConfirmSubHead>
            <DetailsHead>
              {`${transactionFee} POL` || `0.045 POL`}
            </DetailsHead>
          </NftNameConfirm3>
          <NftNameConfirm4>
            <NftNameConfirmSubHead>
              {isList ? "NFT Price" : "Amount Paid"}
            </NftNameConfirmSubHead>
            <AmountHead>
              {price} {currency=="MLD" || fetchDetails?.currency=="MLD"?"$":""}{currency || fetchDetails?.currency}
            </AmountHead>
            <AmountSubHead>{formattedDateTime} </AmountSubHead>
          </NftNameConfirm4>
        </SuccessMain>
        {/* <Button onClick={onClickFun}>
              confirm 
          </Button> */}
        {viewFun && <Button onClick={viewFun}>view</Button>}
        {/* <Button onClick={onClickFun}>
          Confirm
        </Button> */}
      </Root>
    </OverLay>
  );
};

export default ConfirmPopup;
